// @flow
import type { State } from "./createCourse";

export const selectCurricula = ({
  createCourse: { curricula },
}: {
  createCourse: State,
}): {} => curricula;
